<template>
	<Modal @close="$emit('close')" class="delete-location" ref="deleteModal" size="small">
		<div class="container">
			<div class="row">
				<div class="col-12 text-center">
					<h3>Delete {{ location.name }}</h3>
				</div>
			</div>
			<div class="row">
				<div class="col-12 text-center">
					<p>The selected item will be deleted from the application permanently.</p>
				</div>
			</div>
			<div class="row">
				<div class="col-12 text-right">
					<button class="button-action button-action-delete" @click="deleteLocation">Delete</button>
					<button class="button-action button-action-cancel" @click="$refs.deleteModal.close()">Cancel</button>
				</div>
			</div>
		</div>
	</Modal>
</template>

<script>
import Modal from './../Modal.vue'

export default {
  components: {
		Modal
	},
	props: [
		'location'
	],
	methods: {
		deleteLocation() {
			this.$store.commit('app/setLoading', true)
			this.$store.dispatch(`locations/delete`, this.location)
			.then(() => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'success',
					message: `${this.location.name} Deleted`,
					timeout: 3000
				})
				this.$emit('close')
			})
			.catch(err => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'An Error occurred, please try later',
					timeout: 3000
				})
			})
		}
	}
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/Locations/Delete.vue